import React from 'react';
import { IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';
import { brand } from '../../theme/colors';

/**
 * Reusable close button for Dialogs.
 * Positioned absolutely in the top-right corner of the Dialog paper.
 * Must be placed as a direct child of <Dialog>.
 */
const DialogCloseButton = ({ onClick, sx = {}, ...props }) => (
  <IconButton
    aria-label="close"
    onClick={onClick}
    sx={{
      position: 'absolute',
      right: 8,
      top: 8,
      color: brand.primary,
      zIndex: 10,
      pointerEvents: 'auto',
      ...sx,
    }}
    {...props}
  >
    <Close />
  </IconButton>
);

export default DialogCloseButton;
